import { render } from "./SMenu.vue?vue&type=template&id=086e8ad4"
import script from "./SMenu.vue?vue&type=script&lang=js"
export * from "./SMenu.vue?vue&type=script&lang=js"

import "./SMenu.vue?vue&type=style&index=0&id=086e8ad4&lang=css"

import exportComponent from "/home/baltazor/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__